import { apiClient } from '../utils/api';

// Base notification interface matching backend CleanNotificationResponse
export interface ApiNotification {
  id: string;
  receiverId: string;
  receiverType: 'USER' | 'VENDOR' | 'ADMIN';
  status: 'UNREAD' | 'READ';
  timestamp: string;
  type: 'ORDER' | 'QUESTION' | 'REVIEW' | 'PAYMENT' | 'SYSTEM' | 'ALERT' | 'VENDOR_APPLICATION' | 'VENDOR_APPROVAL' | 'VENDOR_REJECTION';
  title: string;
  message: string;
  metadata?: Record<string, any>;
}

export interface NotificationsApiResponse {
  success: boolean;
  data: ApiNotification[];
  count: number;
  countByType: {
    Orders: number;
    Questions: number;
    Reviews: number;
    Other: number;
  };
}

// Get all notifications
export const getNotifications = async (): Promise<NotificationsApiResponse> => {
  const response = await apiClient.get<NotificationsApiResponse>('/vendors/notifications');
  return response.data;
};

// Mark notification as read (you can implement this when the API endpoint is ready)
export const markAsRead = async (notificationId: string): Promise<any> => {
  const response = await apiClient.put(`/vendors/notifications/${notificationId}/mark-read`);
  return response.data;
};

// Mark all notifications as read (you can implement this when the API endpoint is ready)
export const markAllAsRead = async (): Promise<any> => {
  const response = await apiClient.put('/vendors/notifications/mark-all-read');
  return response.data;
};



